/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import './CardPayment.scss';
import { ButtonRadio } from '@core/ButtonRadio';
import { appCardStyle, getKeyByValue, appIconsPath } from '@utils/globalConstant';
import PropTypes from 'prop-types';
import useCmsImage from '@utils/useCmsImage';
import { Ta11yImage } from '@core/Ta11yImage';
import Icons from '@core/Utils/Icons/Icons';
import { sanitizeRichText } from '@utils/sanitizeHtml';

export function CardPayment({
  cardStyle = appCardStyle.DEFAULT,
  icon = null,
  iconRef = null,
  headline = '',
  text = '',
  isChecked = false,
  name = '',
  id = '',
  onClick = () => {},
  invalid = false
}) {
  const paymentImage = useCmsImage(iconRef);
  const cardIcon = getKeyByValue(appIconsPath,icon);
  return (
    <div
      className={`${cardStyle} rounded py-8 ps-8 pe-12`}
      role="button"
      tabIndex={-1}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          console.log('Enter key pressed');
        }
      }}>
      <div className="w-100 d-flex justify-content-between">
        <div className="d-flex align-items-center">
          <div className="img-container br-8">
            {icon && <Icons name={cardIcon} height={24} alt="payment-icon" colorType='dark' />}
            {iconRef && <Ta11yImage imageContent={paymentImage} className="img-fluid" />}
          </div>
          <div
            className="ek-copy-sm-14-semibold px-3"
            dangerouslySetInnerHTML={{ __html: sanitizeRichText(headline) }}
          />
        </div>
        <div className="d-flex align-items-center">
          <ButtonRadio
            name={name}
            id={id}
            isChecked={isChecked}
            invalid={invalid}
            onClick={onClick}
          />
        </div>
        {text && (
          <div className="col-12">
            <div className="space-8" />
            <div className="ek-labeltext-12-medium" dangerouslySetInnerHTML={{ __html: sanitizeRichText(text) }} />
          </div>
        )}
      </div>
    </div>
  );
}

CardPayment.propTypes = {
  cardStyle: PropTypes.string,
  icon: PropTypes.string,
  headline: PropTypes.string.isRequired,
  text: PropTypes.any,
  isChecked: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  invalid: PropTypes.bool
};

export default CardPayment;
